/**
 * 端到端呼叫 · Ant Design 5 主题
 * 来源：console/src/theme.ts
 * 必须与 ui-tokens.css :root 同步。改气质只改这一处和 :root。
 */
import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0071e3',
    colorInfo: '#0071e3',
    colorSuccess: '#248a3d',
    colorWarning: '#b25000',
    colorError: '#d70015',
    colorText: '#1d1d1f',
    colorTextSecondary: '#6e6e73',
    colorTextTertiary: '#86868b',
    colorBorder: 'rgba(0,0,0,0.08)',
    colorBorderSecondary: 'rgba(0,0,0,0.06)',
    colorBgLayout: '#f5f5f7',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", "Hiragino Sans GB", "Noto Sans SC", sans-serif',
    fontSize: 15,
    lineHeight: 1.47,
    controlHeight: 40,
    controlHeightLG: 44,
    boxShadow: '0 1px 2px rgb(0 0 0 / 6%), 0 1px 1px rgb(0 0 0 / 4%)',
    boxShadowSecondary: '0 8px 28px rgb(0 0 0 / 12%), 0 2px 8px rgb(0 0 0 / 6%)',
  },
  components: {
    Button: {
      fontWeight: 590,
      paddingInline: 16,
      defaultBorderColor: 'rgba(0,0,0,0.08)',
      defaultBg: 'rgba(0,0,0,0.04)',
    },
    Input: {
      activeBorderColor: '#0071e3',
      hoverBorderColor: 'rgba(0,0,0,0.18)',
    },
    Table: {
      headerBg: 'transparent',
      headerColor: '#6e6e73',
      headerSplitColor: 'transparent',
      rowHoverBg: 'rgba(0,0,0,0.03)',
      borderColor: 'rgba(0,0,0,0.06)',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
    },
    Card: {
      paddingLG: 20,
    },
    Tag: {
      borderRadiusSM: 999,
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: 'rgba(0,0,0,0.06)',
      itemSelectedColor: '#1d1d1f',
      itemHoverBg: 'rgba(0,0,0,0.04)',
      itemColor: '#1d1d1f',
      itemBorderRadius: 10,
      iconSize: 16,
    },
    Modal: {
      borderRadiusLG: 18,
    },
    Dropdown: {
      borderRadiusLG: 12,
    },
  },
};
